import $i18n from '../i18n';
import { Message } from '@b-design/fusion';

export const LOGO =
  window.__SUPERAPP_CONFIG__?.logo ||
  'https://gw.alicdn.com/imgextra/i3/O1CN01YEo2JD1vfeZseO7cI_!!6000000006200-2-tps-220-210.png';

export const TITLE =
  window.__SUPERAPP_CONFIG__?.title ||
  $i18n?.get({ id: 'aopf.components.HeaderTitle.ChineseSuperapp', dm: 'SuperApp' });

export const COPYRIGHT =
  window.__SUPERAPP_CONFIG__?.copyright?.[$i18n?.i18nLanguage] ||
  $i18n?.get({
    id: 'aopf.pages.login.AlibabaCloudAllRightsReserved',
    dm: '© 2009-2025 Copyright by Alibaba Cloud. All Rights Reserved.',
  });

  const memberRoleList = window.__SUPERAPP_CONFIG__?.role?.split(',') || [];

  export const HasOperatorRole = ()=> memberRoleList.includes('OPERATOR');
  export const HasAigcRole = ()=> memberRoleList.includes('AIGC_DESIGNER');

  export const isPublicDeploy = () => {
    return process.env.ICE_DEPLOY_ENV === 'public';
  };

  export const LOGINPAGETITLE =
    window.__SUPERAPP_CONFIG__?.loginPage?.title?.[$i18n?.i18nLanguage] ||
    $i18n.get({
      id: 'aopf.pages.login.title',
      dm: '欢迎来到SuperApp应用开放平台',
    });

  export const LOGINPAGEDESC =
    window.__SUPERAPP_CONFIG__?.loginPage?.description?.[$i18n?.i18nLanguage] ||
    $i18n.get({
      id: 'aopf.pages.login.subTitle',
      dm: '欢迎来到一个一站式开发平台，提供集成式、情境化和高效的体验。',
    });

  /**
   *
   * @param {string} value 需要copy的内容
   * @param {*} e
   */
  export const copy = (value, e) => {
    e.stopPropagation();
    const input = document.createElement('input');
    input.value = value;
    document.body.appendChild(input);
    input.select();
    if (document.execCommand('Copy')) {
      document.execCommand('Copy');
      document.body.removeChild(input);
      Message.success({
        title: $i18n.get({
          id: 'aopf.src.menuConfig.CopySuccess',
          dm: '复制成功',
        }),
      });
    }
  };
